import { render, staticRenderFns } from "./ClientAppSettingKindForm.vue?vue&type=template&id=436fe7e0&"
import script from "./ClientAppSettingKindForm.vue?vue&type=script&lang=ts&"
export * from "./ClientAppSettingKindForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports